module.exports = __webpack_public_path__ + "static/images/monet/route_list_line_separator.gif";